export const SHORT_DATE_FORMAT = Intl.DateTimeFormat(
  'en-US',
  {style: 'numeric', month: '2-digit', day: '2-digit', year: 'numeric', },
);

export const FULL_DATE_FORMAT = Intl.DateTimeFormat(
  'en-US',
  {style: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', year: 'numeric', },
);

export const PARTIAL_DATE_FORMAT = Intl.DateTimeFormat(
  'en-US',
  {style: 'numeric', month: '2-digit', day: '2-digit', },
);

export const PARTIAL_DATE_FORMAT_WITH_WEEKDAY = Intl.DateTimeFormat(
  'en-US',
  {style: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', },
);

export const TIME_FORMAT = Intl.DateTimeFormat(
  'en-US',
  {style: 'numeric', hour: '2-digit', minute: '2-digit', },
);

export const DOLLAR_FORMAT = Intl.NumberFormat(
  'en-US',
  {style: 'currency', currency: 'USD', },
);


// WEBPACK FOOTER //
// ./src/shared/helpers/formats.js